import React, { useMemo } from "react";
import MaterialIcon from "../../../shared/components/MaterialIcon";
import MetricStatCard, { METRIC_STATS_GRID_CLASS } from "../../../shared/components/MetricStatCard";
import { useTranslation } from "../../../i18n";

function formatRating(value, locale) {
  const formatted = Number(value).toFixed(1);
  return locale === "de" ? formatted.replace(".", ",") : formatted;
}

function renderMetricValue(stats, key, locale) {
  switch (key) {
    case "total":
      return stats.totalReviews;
    case "average":
      return (
        <span className="inline-flex items-baseline gap-1.5">
          <span className="text-4xl font-bold tabular-nums">
            {formatRating(stats.averageRating, locale)}
          </span>
          <MaterialIcon name="star" className="text-[20px] text-secondary" />
        </span>
      );
    case "newToday":
      return stats.newToday;
    case "negative":
      return stats.negative;
    default:
      return 0;
  }
}

const ReviewsMetricsCards = ({ stats, loading = false }) => {
  const { t, locale } = useTranslation();

  const metricCards = useMemo(
    () => [
      {
        key: "total",
        label: t("metrics.reviewsTotal"),
        hint: t("metrics.reviewsTotalHint"),
        borderClass: "border-primary",
        icon: "reviews",
        iconTone: "primary",
      },
      {
        key: "average",
        label: t("metrics.reviewsAverage"),
        hint: t("metrics.reviewsAverageHint"),
        borderClass: "border-secondary",
        icon: "star",
        iconTone: "secondary",
      },
      {
        key: "newToday",
        label: t("metrics.reviewsNewToday"),
        hint: t("metrics.reviewsNewTodayHint"),
        borderClass: "border-yellow-500",
        icon: "today",
        iconTone: "yellow",
      },
      {
        key: "negative",
        label: t("metrics.reviewsCritical"),
        hint: t("metrics.reviewsCriticalHint"),
        borderClass: "border-error",
        icon: "warning",
        iconTone: "error",
      },
    ],
    [t]
  );

  if (loading) {
    return (
      <div className={`mb-8 ${METRIC_STATS_GRID_CLASS}`}>
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="tonal-card h-[140px] animate-pulse rounded-xl border-l-4 border-outline-variant"
          />
        ))}
      </div>
    );
  }

  if (!stats) return null;

  return (
    <div className={`mb-8 ${METRIC_STATS_GRID_CLASS}`}>
      {metricCards.map((card) => (
        <MetricStatCard
          key={card.key}
          label={card.label}
          hint={card.hint}
          value={renderMetricValue(stats, card.key, locale)}
          icon={card.icon}
          iconTone={card.iconTone}
          borderClass={card.borderClass}
        />
      ))}
    </div>
  );
};

export default ReviewsMetricsCards;
